import React, { useContext } from 'react'
import { GlobalContext } from '../context/GlobalState'

const Alerts = () => {
  const context = useContext(GlobalContext)

  return (
    context.alerts.length > 0 && context.alerts.map(alert => (
      <div className={`alert alert-${alert.type}`} key={alert.id}>
        {alert.type === 'success' ? (  
          <i className="fas fa-check-circle"></i> ) : (
          <i className="fas fa-exclamation-triangle"></i> )
        }
        <span>{alert.msg}</span>
      </div>
    ))
  )
}

export default Alerts